export const INIT: "plugins/INIT" = "plugins/INIT";
export const SET_STATE: "plugins/SET_STATE" = "plugins/SET_STATE";
export const SET_PLUGIN_EVENTS: "plugins/SET_PLUGIN_EVENTS" =
  "plugins/SET_PLUGIN_EVENTS";
export const SET_STORY: "plugins/SET_STORY" = "plugins/SET_STORY";
export const SHOW_MODAL: "plugins/SHOW_MODAL" = "plugins/SHOW_MODAL";
export const CLOSE_MODAL: "plugins/CLOSE_MODAL" = "plugins/CLOSE_MODAL";
